export default "__VITE_ASSET__Bd$bvpjJ__"